import React, {useState} from 'react';
import {Col, Row} from 'reactstrap';

import {ButtonNew} from "../../../components/buttons/buttonsActions";
import SalesPackageList from "./_list";
import SalesPackageForm from "./_form";

export default function SalesPackage(props){
    const [editMode, setEditMode] = useState(false);
    const [item, setItem] = useState();
    const [listState, setListState] = useState(null);

    // Modo de vista: LIST, FORM
    const [viewMode, setViewMode] = useState("LIST")

    const setForm = (editModeP, data, viewModeP) => {
        setEditMode(editModeP ? editModeP : editMode);
        setItem(data);
        setViewMode(viewModeP ? viewModeP : "LIST")
    }

    const updateItem = (item) => {
        setItem(item)
    }

    return (
        <div>
            {/*--------------------------------------------------------------------------------*/}
            {/* Header*/}
            {/*--------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            viewMode === "LIST" ?
                                <div className="ml-auto paddingAdd">
                                    <ButtonNew onClick={() => setForm(null, null, "FORM")}/>
                                </div> : null
                        }
                    </div>
                </Col>
            </Row>
            {(
                function() {
                    switch (viewMode) {
                        case "LIST" :
                            return (
                                <Row>
                                    <Col md="12">
                                        <SalesPackageList setForm={setForm} app={props.app} listState={listState} setListState={setListState}/>
                                    </Col>
                                </Row>
                            );
                        case "FORM" :
                            return (
                                <Row>
                                    <Col md="12">
                                        <SalesPackageForm setForm={setForm} updateItem={updateItem} item={item} editMode={editMode} app={props.app} />
                                    </Col>
                                </Row>
                            );
                        default:
                            return null;
                    }
                })()}
        </div>
    );
}
